export const rules = (state = [], action) => {
  switch(action.type) {
    case 'SET_RULES':
      return action.rules
    default:
      return state
  }
}